export const StringsEN = {
    // Buttons
    buttons: {
        button_back: 'Back',
        button_loginGoogle: 'Login with Google',
        button_loginMicrosoft: 'Login with Microsoft',
        button_accept: 'Accept',
        button_cancel: 'Cancel',
        button_logout: 'Logout',
        button_settings: 'Settings',
        button_save: 'Save',
        button_exit: 'Exit',
        button_edit: 'Edit',
        button_openDicom: 'Open DICOM',
        button_classify: 'Classify',
        button_data: 'Data',
        button_modify: 'Modify',
        button_results: 'Results',
    },
    // Errors
    errors: {
        // Login errros 
        loginErrorUnknownUser: 'User with no access rights',
        loginErrorUnknown: 'Unknown login error',
        // Format (generic validators)
        error_maxValue: 'Value too large',
        error_minValue: 'Value to small',
        error_step: 'Resolution error',
        error_required: 'Required field',
        error_maxLength: 'To many characters',
        error_specialCharacters: 'Special characters are not allowed',
        error_spacesInString: 'Spaces are not allowed',
        error_dicomNotInCm: 'This DICOM file cannot be processed. The physical units of the image are not in centimetres',
    },
    // General app strings
    appStrings: {
        waitingMessageLoadDicom: 'Loading DICOM. Please, wait...',
        waitingMessageClassifyDicom: 'Classifying DICOM image. Please, wait...',
        waitingMessageModifyingData: 'Updating segmentation. Please, wait...',
        waitingMessageGeneratingResults: 'Generating results. Please, wait...',
        imagePlaceholder: 'DICOM image display area'
    },
    // Additional data popup
    additionalDataPopupStrings: {
        title: 'Patient data',
        inputBoxLabelPatientAge: 'Age (years)',
        inputBoxLabelPatientWeight: 'Weight (kg)',
        inputBoxLabelPatientHeight: 'Height (m)',
        radioButtonTitlePatientSex: 'Sex:',
        radioButtonLabelsPatientSex: ['Male', 'Female', 'Other'],
    },
    // User feedback strings
    feedbackStrings:{
        successfullySaved: 'Successfully saved',
        noRemainingAnalysis: 'No analysis remaining. Contact support',
        licenseExpired: 'Your license has expired. Contact support',
    },
    // Popups
    popups: {
        titleSaveChanges: 'Unsaved changes',
        textSaveChanges: 'Do you want to save them?',
        inputBoxLabelPatientId: 'Patient ID',
        inputBoxLabelStudyId: 'Study ID',
        titleSetPatientId: 'DICOM data has been anonymized. Please, set new identifiers to be used in the result files:',
    },
}
